import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { StyledButton, StyledInput } from "./Styles";
import Message from "./Message";
import axiosInstance from "../config/axiosConfig";

function Consultation({ text }) {
  const { t, i18n } = useTranslation();
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const consultationRequest = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    const formData = new FormData(event.target);
    const values = Object.fromEntries(formData.entries());

    try {
      const response = await axiosInstance.post("/api/consultation-request/", {
        name: values.name || null,
        email: values.email || null,
        description: values.description || null,
      });
      setMessage(response.data.detail);
      event.target.reset();
    } catch (error) {
      if (error.response) {
        setError(
          error.response.data.detail || t("consultation.errors.general")
        );
      } else {
        setError(t("consultation.errors.network"));
      }
    }
  };

  return (
    <StyledInput.FormContainer lang={i18n.language}>
      <h3>{text || t("consultation.title")}</h3>

      {message && <Message variant="success">{message}</Message>}
      {error && <Message variant="error">{error}</Message>}

      <form onSubmit={consultationRequest}>
        <StyledInput.InputGroup>
          <StyledInput.Input
            type="text"
            placeholder={t("consultation.inputs.name")}
            name="name"
            lang={i18n.language}
          />
          <StyledInput.Input
            type="email"
            placeholder={t("consultation.inputs.email")}
            name="email"
            lang={i18n.language}
          />
        </StyledInput.InputGroup>

        <StyledInput.InputGroup>
          <StyledInput.TextArea
            rows="5"
            placeholder={t("consultation.inputs.message")}
            name="description"
            lang={i18n.language}
          />
        </StyledInput.InputGroup>

        <StyledButton.Main>
          {t("consultation.submit")}
        </StyledButton.Main>
      </form>
    </StyledInput.FormContainer>
  );
}

export default Consultation;